import { BookOpen } from "lucide-react";
import { useT } from "../lib/LangContext";
import { useReadingStreak } from "../lib/readerHistory";

// Habit-signal shown at the bottom of the ArticlePage once a reader has
// consumed at least 2 unique stories in the last 7 days. Below the
// floor we hide it so it never reads "you've read 1 story" — that would
// undermine, not reinforce, the habit. Once shown it's a lightweight
// nudge that turns curious visitors into returning readers.
const FLOOR = 2;

export const ReadingStreak = () => {
  const { t } = useT();
  const count = useReadingStreak(7);
  if (count < FLOOR) return null;
  const text = (t("streak_read_stories") || "You've read {count} stories this week")
    .replace("{count}", String(count));
  return (
    <div
      className="max-w-3xl mx-auto px-4 sm:px-6 mt-8"
      data-testid="reading-streak"
    >
      <div className="inline-flex items-center gap-2 rounded-full bg-[#0AADA0]/10 text-[#0AADA0] text-[13px] px-4 py-2">
        <BookOpen size={14} />
        <span>{text}</span>
      </div>
    </div>
  );
};
